import twemoji from 'twemoji'
import $ from 'jquery';

export default class Stickerify {
  constructor(options){
    this.$element = $(options.element);

    this.stickerPrioritize = [
      "semangat", "hebat", "indonesia", "juara"
    ];

    this.stickerBola = [
      "sedih", "ayo", "gol", "pelanggaran", "kartumerah", "sriwijaya", "mitrakukar", "persija", "arema", "maduraunited", "persib", "perseru", "semenpadang", "psm", "pusamania", "baliunited", "persegres", "persipura", "barito", "surabayaunited", "persiba", "pstni", "persela"
    ];

    this.stickerCandy = [
      'CandyAngry', 'CandyBirthday', 'CandyBored', 'CandyBroke', 'CandyDizzy', 'CandyDontcare', 'CandyGrumpy', 'CandyHi', 'CandyHurray', 'CandyIdea', 'CandyKiss', 'CandyLaugh', 'CandyLove', 'CandyMakeup', 'CandySad', 'CandySick', 'CandySorry', 'CandyThanks', 'CandyWait', 'CandyWink'
    ];

    this.stickerCotton = [
      'cottonangel', 'cottonbequiet', 'cottonblush', 'cottoncallme', 'cottoncold', 'cottonconfused', 'cottondevil', 'cottonembarrassed', 'cottonfire', 'cottongrin', 'cottongrumpy', 'cottonhi', 'cottonhot', 'cottonjawdrop', 'cottonlaugh', 'cottonletsgo', 'cottonlove', 'cottonmad', 'cottonno', 'cottonokay', 'cottononmyway', 'cottonpickafight', 'cottonraisehand', 'cottonsad', 'cottonshock', 'cottonsick', 'cottonsigh', 'cottonsleep', 'cottonthumbsdown', 'cottonthumbsup', 'cottonyawn', 'cottonyikes'
    ];

    this.stickerList = [].concat(window.stickers, this.stickerPrioritize, this.stickerBola, this.stickerCandy, this.stickerCotton);
    this.stickersRegexString = this.stickerList.map((kata) => { return `(^\\b${kata}\\b$)`; }).join('|');

    this.regex = new RegExp(this.stickersRegexString, 'gi');
    this.twemojiPath = window.Config.AssetHostName.replace('%d', Math.floor(Math.random()*2)) + '/assets/images/twemoji/';
  }

  init(){
    this.insertTwemoji();
    this.insertSticker();
  }

  insertSticker() {
    const node = this.$element;
    const matches = node.text().match(this.regex);

    if (matches !== null) {
      node.text("");

      const stickerText = matches[0].toLowerCase();
      node.addClass(`sticker sticker-${stickerText}`);
      node.attr('title', stickerText);
      node.attr('aria-label', `Emoji: ${stickerText}.`);
    }
  }

  insertTwemoji() {
    const twemojiParse = twemoji.parse(this.$element.html());
    this.$element.html(twemojiParse);
    this.bindOnErrorImage();
  }

  bindOnErrorImage() {
    $('img.emoji').on('error', twemoji.onerror)
  }
}
